import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import OverlayMerchandise from '../OverlayMerchandise';
import Markdown from '../../../components/Markdown';

const propTypes = {
  overlayContent: PropTypes.string,
};

const SunseekerPromoPopup = ({ overlayContent }) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const checkOverlays = () => {
    const popupDisplayed = window.sessionStorage.getItem(
      'sunseekerPopupDisplay'
    );
    let isPopupSessionStored = false;

    if (!popupDisplayed) {
      isPopupSessionStored = true;
      window.sessionStorage.setItem('sunseekerPopupDisplay', true);
    }

    setIsPopupOpen(isPopupSessionStored);
  };

  useEffect(() => {
    checkOverlays();
  }, [setIsPopupOpen]);

  return (
    <>
      {isPopupOpen && (
        <Markdown
          source={overlayContent}
          customElements={{ OverlayMerchandise }}
        />
      )}
    </>
  );
};

SunseekerPromoPopup.propTypes = propTypes;
export default SunseekerPromoPopup;
